﻿import {UIBase} from "./Tools/Base/UIBase";
import {UIImage} from "./Tools/Base/UIImage";

export class LastMonsterAnimation extends UIBase {

    Awake() {
        super.Awake();
        this.moveObject = null; // RectTransform moveObject;
        this.monsterImage  = this.addChild(new UIImage()); // Image monsterImage;
        this.CanvasRect = null; // RectTransform CanvasRect;
        this.scaleCurve = null; // AnimationCurve scaleCurve;
        this.to = null; // Vector3
        this.from = null; // Vector3
        this.move = false;
        this.moveT = 0;
//        monsterImage.gameObject.SetActive(false);
    }

    // int creatureId, Vector3 worldPosition
    Show(creatureId, worldPosition) {
//        var cnv = GetComponentInParent<Canvas>();
//
//        var epoch = Core.GameData.Epochs.GetByCreatureId(creatureId);
//        to = Core.UI.game.epochsList.GetItem(epoch.id).epochIconImage.transform.position;
//        to = new Vector3(
//            to.x / cnv.scaleFactor - CanvasRect.sizeDelta.x * 0.5f,
//            to.y / cnv.scaleFactor - CanvasRect.sizeDelta.y * 0.5f,
//            0
//            );
//
//        Vector2 ViewportPosition = Camera.main.WorldToViewportPoint(worldPosition);
//        from = new Vector2(
//            ((ViewportPosition.x * CanvasRect.sizeDelta.x) - (CanvasRect.sizeDelta.x * 0.5f)),
//            ((ViewportPosition.y * CanvasRect.sizeDelta.y) - (CanvasRect.sizeDelta.y * 0.5f)));
//
//        moveT = 0f;
//        move = true;
//        monsterImage.sprite = `creatures/${creatureId}`;
//        monsterImage.gameObject.SetActive(true);
    }

    Update() {
//        if (move)
//        {
//            moveT += Time.deltaTime * 1.25f;
//
//            var pos = Vector3.Lerp(from, to, moveT);
//
//            moveObject.anchoredPosition = pos;
//            moveObject.localScale = Vector3.one * scaleCurve.Evaluate(moveT);
//
//            if (moveT >= 1f)
//            {
//                move = false;
//                monsterImage.gameObject.SetActive(false);
//            }
//        }
    }
}

